// src/utils/localTime.ts

const bisect = (low: number, high: number, pred: (n: number) => boolean) => {
  // assert (!pred(x), x <= low) && (pred(x), x >= high)
  while (low + 1 < high) {
    const mid = Math.floor((low + high) / 2);
    // assert low < mid < high
    if (pred(mid)) {
      // assert pred(x), x >= mid
      high = mid;
      // assert (!pred(x), x <= low) && (pred(x), x >= high)
    } else {
      // assert !pred(x), x <= mid
      low = mid;
      // assert (!pred(x), x <= low) && (pred(x), x >= high)
    }
    // assert (!pred(x), x <= low) && (pred(x), x >= high)
  }
  // assert (!pred(x), x <= low) && (pred(x), x >= high)
  // assert low + 1 == high
  // assert (!pred(x), x < high) && (pred(x), x >= high)
  return high;
};

export const toLocalDateString = (date: Date): string => 
  date.toLocaleString('en-US', {timeZone: 'America/New_York'});

export const toLocalMonthDay = (date: Date): string => date.toLocaleString(
  'en-US', {timeZone: 'America/New_York', month: 'short', day: 'numeric'}
);

export const toLocalYearMonthDay = (date: Date): string => date.toLocaleString(
  'en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }
);

export const toLocalYearMonth = (date: Date): string => date.toLocaleString(
  'en-US', {timeZone: 'America/New_York', year: 'numeric', month: 'short'}
);

export const toLocalYear = (date: Date): string => date.toLocaleString(
  'en-US', {timeZone: 'America/New_York', year: 'numeric'}
);

export const toLocalDate = (
  date: Date
): [number, number, number, number, number, number] => {
  const s = toLocalDateString(date);
  // 10/17/2024, 12:04:54 PM
  const re = /(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+) (AM|PM)/
  const m = re.exec(s);
  if (m === null) {
    return [NaN, NaN, NaN, NaN, NaN, NaN];
  }
  return [
    parseInt(m[3])                                  , // year
    parseInt(m[1]) - 1                              , // monthIndex
    parseInt(m[2])                                  , // day
    parseInt(m[4]) % 12 + ((m[7] === 'PM') ? 12 : 0), // hours
    parseInt(m[5])                                  , // minutes
    parseInt(m[6])                                    // seconds
  ];
};

const currentLocalDate = (target: number[]): Date => {
  return new Date(bisect(
    0,
    new Date(target[0] + 1, 0).getTime(),
    t => {
      const date = toLocalDate(new Date(t));
      for (let i = 0; i < target.length; ++i) {
        if (target[i] < date[i]) { return true ; }
        if (target[i] > date[i]) { return false; }
      }
      return true;
    }
  ));
};

export const fromLocalDate = (
  year: number, monthIndex: number, day: number,
  hours: number, minutes: number, seconds: number
): Date => currentLocalDate([year, monthIndex, day, hours, minutes, seconds]);

const incLast = (a: number[]) => {
  ++a[a.length - 1];
  return a;
};

export const currentLocalYear = (date: Date): Date =>
  currentLocalDate(toLocalDate(date).slice(0, 1));

export const currentLocalMonth = (date: Date): Date =>
  currentLocalDate(toLocalDate(date).slice(0, 2));

export const currentLocalDay = (date: Date): Date =>
  currentLocalDate(toLocalDate(date).slice(0, 3));

export const currentLocalHour = (date: Date): Date =>
  currentLocalDate(toLocalDate(date).slice(0, 4));

export const nextLocalYear = (date: Date): Date =>
  currentLocalDate(incLast(toLocalDate(date).slice(0, 1)));

export const nextLocalMonth = (date: Date): Date =>
  currentLocalDate(incLast(toLocalDate(date).slice(0, 2)));

export const nextLocalDay = (date: Date): Date =>
  currentLocalDate(incLast(toLocalDate(date).slice(0, 3)));

export const nextLocalHour = (date: Date): Date =>
  currentLocalDate(incLast(toLocalDate(date).slice(0, 4)));
